import { createContext } from 'react';
var ChartContext = createContext();
ChartContext.displayName = 'ChartContext';
export default ChartContext;